// 公共模块
import http from './utils';
import { mockPrefix, permissionPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

// ========== 事件时间轴相关类型 ==========

/**
 * 事件时间轴接口响应
 */
export interface IEventStatsTimelineResponse {
  event_list: {
    [eventType: string]: Array<IEventItem>;
  };
  event_timeline: {
    [timestamp: string]: {
      count: number;
      event_list: {
        [eventType: string]: Array<IEventItem & { time: string }>;
      };
    };
  };
}

/**
 * 事件项基础类型
 */
export interface IEventItem {
  name: string;
  name_cn?: string;
  description?: string;
  description_cn?: string;
  event_type: string;
  event_type_cn?: string;
  start_time: string;
  end_time: string;
  country?: string;
  source?: string;
  url?: string;
  event_priority?: string;
  entity_type?: string;
}

export const listMenu: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/listMenu`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const operationLog: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${permissionPrefix}/operationLog`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const getFilterValueDefaultConfig: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/game/default_config`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const getGlobalPageSourceRule: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/global/page_source_rule`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const getGlobalExclusiveGroup: () => Promise<any> | any = () => { 
  return http({
    url: `${prefix}/global/exclusive_group`,
    method: 'post',
    errorHandler: true,
  }) as Promise<any>;
};

export const getGlobalResourceConfig: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/resource/last_available_time`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 获取事件时间轴数据
 * API: POST /api/v1/opinion_pc/overview/event_stats_timeline
 */
export function getEventStatsTimeline(
  payload: any,
): Promise<IEventStatsTimelineResponse> {
  return http({
    url: `${prefix}/overview/event_stats_timeline`,
    method: 'post',
    ...payload,
  }) as Promise<IEventStatsTimelineResponse>;
}
